export interface CalendarActivity {
  event: GestationalCalendarEvent
  event_date: string
  id: string
  animal_event: string
  is_completed: boolean
}

export interface GestationCalendarEventRequest {
  animal_event_type: string
  description: string
  interval_duration: number | null
  is_calving_relative: boolean
  name: string
  species: string
  time_offset: number
}

export const initialGestationalCalendarEvent: GestationCalendarEventRequest = {
  description: "",
  interval_duration: null,
  is_calving_relative: false,
  name: "",
  species: "",
  time_offset: 0,
  animal_event_type: "",
}

export interface GestationalCalendarEvent {
  animal_event_type?: string
  created_at: string
  description: string
  id: string
  interval_duration: number | null
  is_calving_relative: boolean
  name: string
  species: string
  target: string
  time_offset: number
  farm?: string
  base_event?: string
  is_disabled?: boolean
  metadata?: CalendarEventMetadata
  updated_at: string
}

export interface CalendarEventMetadata {
  is_insemination?: boolean
  is_birth_event?: boolean
  is_gestation_confirmation_event?: boolean
  gestation_positive_animal_event_type_name?: string
  gestation_negative_animal_event_type_name?: string
}

export interface GestationCalendar {
  id: string
  animal: string
  insemination_date: string
  calving_date: string
  gestation_confirmed: boolean
  abortion_confirmed: boolean
  is_completed: boolean
  confirmed_calving_date?: string
  entries: CalendarActivity[]
  created_at: string
  updated_at: string
}

export interface GestationCalendarRequest {
  animal: string
  insemination_date: string
}

export enum CalendarActivityState {
  DUE = "DUE",
  CURRENT = "CURRENT",
  DONE = "DONE",
  ABORTED = "ABORTED",
}
